import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import CloseIcon from '../themes/svg/closeIcon';
import config from '../helpers/config';

Modal.setAppElement('#estimateBuilderRoot');

const supportPhoneNumberUrl = `tel:${config.supportPhoneNumber}`;

const GlobalErrorModal = props => (
  <Modal
    isOpen={props.hasGlobalError}
    className="estimatebuilder-modal"
    overlayClassName="estimatebuilder-modal-overlay"
    onRequestClose={props.dismissGlobalError}
    style={{
      content: {
        width: 450,
      },
    }}
  >
    <h2>Uh oh!</h2>
    <div className="modal-close" onClick={() => { props.dismissGlobalError(props.reloadOnClose); }} tabIndex="-1" role="button"><CloseIcon /></div>
    <div className="modal-body">
      {props.errorMessage ? (
        <span>{props.errorMessage}</span>
      ) : (
        <span>Something went wrong. You can try again later,
        create a new estimate, or give us a call at <a href={`tel:${supportPhoneNumberUrl}`}>{config.supportPhoneNumber}</a>.
        We&apos;re happy to help!
        </span>
      )}
    </div>
    <form className="modal-actions">
      <button className="btn btn-primary" onClick={() => { props.dismissGlobalError(props.reloadOnClose); }}>Got It</button>
    </form>
  </Modal>
);

GlobalErrorModal.propTypes = {
  dismissGlobalError: PropTypes.func.isRequired,
  hasGlobalError: PropTypes.bool,
  errorMessage: PropTypes.string,
  reloadOnClose: PropTypes.bool,
};

GlobalErrorModal.defaultProps = {
  hasGlobalError: false,
  errorMessage: null,
  reloadOnClose: false,
};

export default GlobalErrorModal;
